import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

const Home = () => (
  <div style={{ padding: '20px', fontFamily: 'Arial' }}>
    <h1 style={{ color: '#003366' }}>Willkommen bei PERSONALHANSA</h1>
    <p>Dies ist die Mitarbeiteransicht der App.</p>
    <ul>
      <li><Link to="/zeiterfassung">Zeiterfassung</Link></li>
      <li><Link to="/urlaub">Urlaubsantrag</Link></li>
      <li><Link to="/kontakt">Kontakt</Link></li>
      <li><Link to="/datenschutz">Datenschutz & Transparenz</Link></li>
    </ul>
  </div>
);

const Zeiterfassung = () => (
  <div style={{ padding: '20px' }}>
    <h2>Zeiterfassung</h2>
    <p>Hier kannst du deine Arbeitszeit erfassen.</p>
  </div>
);

const Urlaub = () => (
  <div style={{ padding: '20px' }}>
    <h2>Urlaubsantrag</h2>
    <p>Urlaub, Krankheit oder Freizeitausgleich auswählen.</p>
  </div>
);

const Kontakt = () => (
  <div style={{ padding: '20px' }}>
    <h2>Kontakt</h2>
    <p>Telefon: 0621-12 0000</p>
    <p>E-Mail: team@personalhansa.com</p>
    <p>Adresse: P 3, 1-3, Mannheim</p>
  </div>
);

const Datenschutz = () => (
  <div style={{ padding: '20px' }}>
    <h2>Datenschutz & Transparenz</h2>
    <p>Informationen zur Datenverarbeitung in der App.</p>
    <a href="/datenschutzerklaerung_personalhansa.pdf" target="_blank" rel="noopener noreferrer">
      📄 Datenschutzerklärung als PDF herunterladen
    </a>
  </div>
);

const App = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/zeiterfassung" element={<Zeiterfassung />} />
      <Route path="/urlaub" element={<Urlaub />} />
      <Route path="/kontakt" element={<Kontakt />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
    </Routes>
  </Router>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
